import React, { InputHTMLAttributes, forwardRef } from 'react';
import classNames from 'classnames';

export interface SubmitProps extends InputHTMLAttributes<HTMLInputElement> {
  value: string;
}

const Submit = forwardRef<HTMLInputElement, SubmitProps>(
  ({ className, ...rest }: SubmitProps, ref): JSX.Element => {
    return (
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
        ref={ref}
        type="submit"
        className={classNames('usa-button', className)}
      />
    );
  },
);

export default Submit;
